import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "img-container"
};
const _hoisted_2 = {
  class: "image-slot"
};
const _hoisted_3 = {
  class: "task-info"
};
const _hoisted_4 = {
  class: "info-line"
};
const _hoisted_5 = {
  class: "prompt"
};
const _hoisted_6 = {
  class: "info-line"
};
const _hoisted_7 = {
  class: "prompt"
};
const _hoisted_8 = {
  class: "info-line"
};
const _hoisted_9 = {
  class: "wrapper"
};
const _hoisted_10 = {
  class: "item-value"
};
const _hoisted_11 = {
  class: "info-line"
};
const _hoisted_12 = {
  class: "wrapper"
};
const _hoisted_13 = {
  class: "item-value"
};
const _hoisted_14 = {
  class: "info-line"
};
const _hoisted_15 = {
  class: "wrapper"
};
const _hoisted_16 = {
  class: "item-value"
};
const _hoisted_17 = {
  class: "info-line"
};
const _hoisted_18 = {
  class: "wrapper"
};
const _hoisted_19 = {
  class: "item-value"
};
const _hoisted_20 = {
  class: "info-line"
};
const _hoisted_21 = {
  class: "wrapper"
};
const _hoisted_22 = {
  class: "item-value"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "info-line"
};
const _hoisted_25 = {
  class: "wrapper"
};
const _hoisted_26 = {
  class: "item-value"
};
const _hoisted_27 = {
  class: "info-line"
};
const _hoisted_28 = {
  class: "wrapper"
};
const _hoisted_29 = {
  class: "item-value"
};
const _hoisted_30 = {
  class: "info-line"
};
const _hoisted_31 = {
  class: "wrapper"
};
const _hoisted_32 = {
  class: "item-value"
};
const _hoisted_33 = {
  class: "info-line"
};
const _hoisted_34 = {
  class: "wrapper"
};
const _hoisted_35 = {
  class: "item-value"
};
const _hoisted_36 = {
  class: "copy-params"
};
import { ref, watch, onMounted } from "vue";
import Clipboard from "clipboard";
import { showMessageOK, showMessageError } from "@/utils/dialog";
export default {
  __name: 'SdTaskView',
  props: {
    modelValue: Boolean,
    data: Object
  },
  emits: ["drawSame", "close"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const item = ref(props.data);
    const show = ref(props.modelValue);
    const emit = __emit;
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard(".copy-prompt-wall");
      clipboard.value.on("success", () => {
        showMessageOK("复制成功！");
      });
      clipboard.value.on("error", () => {
        showMessageError("复制失败！");
      });
    });
    watch(() => props.modelValue, newValue => {
      show.value = newValue;
    });
    watch(() => props.data, newValue => {
      item.value = newValue;
    });
    const drawSame = item => {
      emit("drawSame", item);
    };
    const close = () => {
      emit("close");
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: show.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => show.value = $event),
        fullscreen: true,
        onClose: close,
        style: {
          "--el-dialog-border-radius": "0px"
        }
      }, {
        header: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "header"
        }, [_createElementVNode("h3", {
          style: {
            "color": "var(--text-theme-color)"
          }
        }, "绘画任务详情")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_image, {
              src: item.value['img_url'],
              fit: "contain"
            }, {
              placeholder: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("div", {
                class: "image-slot"
              }, "正在加载图片", -1)])),
              error: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("i", {
                  class: "iconfont icon-image"
                }, null, -1)])),
                _: 1
              })])]),
              _: 1
            }, 8, ["src"])])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_divider, null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 正向提示词 ")])),
              _: 1
            }), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(item.value.prompt), 1), _createVNode(_component_el_icon, {
              class: "copy-prompt-wall",
              "data-clipboard-text": item.value.prompt
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("i", {
                class: "iconfont icon-copy"
              }, null, -1)])),
              _: 1
            }, 8, ["data-clipboard-text"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_divider, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 反向提示词 ")])),
              _: 1
            }), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.value.params.negative_prompt), 1), _createVNode(_component_el_icon, {
              class: "copy-prompt-wall",
              "data-clipboard-text": item.value.params.negative_prompt
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("i", {
                class: "iconfont icon-copy"
              }, null, -1)])),
              _: 1
            }, 8, ["data-clipboard-text"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[9] || (_cache[9] = _createElementVNode("label", null, "采样方法：", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(item.value.params.sampler), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[10] || (_cache[10] = _createElementVNode("label", null, "图片尺寸：", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(item.value.params.width) + " x " + _toDisplayString(item.value.params.height), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[11] || (_cache[11] = _createElementVNode("label", null, "迭代步数：", -1)), _createElementVNode("div", _hoisted_16, _toDisplayString(item.value.params.steps), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[12] || (_cache[12] = _createElementVNode("label", null, "引导系数：", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString(item.value.params.cfg_scale), 1)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[13] || (_cache[13] = _createElementVNode("label", null, "随机因子：", -1)), _createElementVNode("div", _hoisted_22, _toDisplayString(item.value.params.seed), 1)])]), item.value.params.hd_fix ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_divider, null, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 高清修复 ")])),
              _: 1
            }), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[15] || (_cache[15] = _createElementVNode("label", null, "重绘幅度：", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(item.value.params.hd_redraw_rate), 1)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[16] || (_cache[16] = _createElementVNode("label", null, "放大算法：", -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(item.value.params.hd_scale_alg), 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[17] || (_cache[17] = _createElementVNode("label", null, "放大倍数：", -1)), _createElementVNode("div", _hoisted_32, _toDisplayString(item.value.params.hd_scale), 1)])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[18] || (_cache[18] = _createElementVNode("label", null, "迭代步数：", -1)), _createElementVNode("div", _hoisted_35, _toDisplayString(item.value.params.hd_steps), 1)])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_36, [_createVNode(_component_el_button, {
              type: "primary",
              round: "",
              onClick: _cache[0] || (_cache[0] = $event => drawSame(item.value))
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("画一张同款的")])),
              _: 1
            })])])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};